/* eslint-disable */
jQuery(function ($) {
	// Add current menu class to main nav items when required
	const wrap_classes = document.querySelector( '.bb-grid.site-content-grid .wrap' );
	var menu_item      = '';
	if ( typeof( wrap_classes ) != 'undefined' && wrap_classes != null ) {
		if ( wrap_classes.classList.contains( 'sketchbook' ) ||
			wrap_classes.classList.contains( 'step-by-step' ) ||
			wrap_classes.classList.contains( 'solo' ) ||
			wrap_classes.classList.contains( 'course' ) ) {
			menu_item = document.querySelector( '#primary-menu li.menu-item-5081' );
		} else if ( wrap_classes.classList.contains( 'knowledge-base' ) || wrap_classes.classList.contains( 'practicepics' ) ) {
			menu_item = document.querySelector( '#primary-menu li.menu-item-5082' );
		}
		if ( menu_item ) {
			menu_item.classList.add( 'current-menu-item' );
		}
	} else if ( document.body.classList.contains( 'forum-archive' ) || document.body.classList.contains( 'forum' ) || document.body.classList.contains( 'single-topic' ) ) {
		menu_item = document.querySelector( '#primary-menu li.menu-item-4697' );
		if ( menu_item ) {
			menu_item.classList.add( 'current-menu-item' );
		}
		menu_item = document.querySelector( '#primary-menu li.menu-item-12602' );
		if ( menu_item ) {
			menu_item.classList.remove( 'current-menu-item' );
		}
	}

	// Scroll header menu out of view when down the page
	$( window ).on( 'scroll', function () {
		if ( $( window ).scrollTop() > 150 ) {
			$( '#page, .site-header' ).addClass( 'nav-down' );
		} else {
			$( '#page, .site-header' ).removeClass( 'nav-down' );
		}
	});

	/* PREFERENCES */
	// if current url is /new-member-level/ or /new-member-preferences/ then proceed
    if ( window.location.pathname === '/new-member-level/' || window.location.pathname === '/new-member-preferences/' ) {
		updateFormElements();
    }

	// update form elements for preference form
	function updateFormElements() {
		// If we have a form element
	    if ( 0 === $( 'form#ama-preferences' ).length ) {
			return;
		}
		// on load enable button if option is selected
		if ( hasOptionSelected() ) {
			$( 'form#ama-preferences input[type="submit"]' ).removeClass( 'disabled' );
		}
		// on option change enable button if option is selected
		$( 'form#ama-preferences input[type="radio"], form#ama-preferences input[type="checkbox"]' ).on( 'change', function() {
			$( 'form#ama-preferences aside.bp-feedback' ).remove();
			if ( hasOptionSelected() ) {
				$( 'form#ama-preferences input[type="submit"]' ).removeClass( 'disabled' );
			} else {
				$( 'form#ama-preferences input[type="submit"]' ).addClass( 'disabled' );
			}
		});
		// on button click, show notice if button is disabled
		$( 'form#ama-preferences input[type="submit"]' ).on( 'click', function( e ) {
			$( 'form#ama-preferences aside.bp-feedback' ).remove();
			if ( ! $( this ).hasClass( 'disabled' ) ) {
				return;
			}
			e.preventDefault();
			var message = 'Please select an option to continue.';
			if ( $( 'form#ama-preferences .section.styles' ).length > 0 ) {
				message = 'Please select at least one option to continue.';
			}
			$( '<aside class="bp-feedback bp-messages warning"><span class="bp-icon" aria-hidden="true"></span><p>'+message+'</p></aside>').insertBefore( 'form#ama-preferences input[type="submit"]' );
		});
	}


    // check if radio or checkbox option is selected
    function hasOptionSelected() {
		if ( $( 'form#ama-preferences input[type="radio"]:checked' ).length > 0 ) {
			return true;
		}
		if ( $( 'form#ama-preferences input[type="checkbox"]:checked' ).length > 0 ) {
			return true;
		}
        return false;
    }
	/* END PREFERENCES */
	// Add functionality for bookmarks
	// Bookmarking on single tutorial page under header
    $( '.additional-info-wrap' ).on( 'click', '#add-bookmark, #remove-bookmark', function( e ) {
        e.preventDefault();
        var anchor = $( this );
        var save   = anchor.closest( '.save' );
        anchor.find( '.spinner' ).addClass( 'is-active' );
        anchor.find( '.bookmark' ).hide();
        var data = {
            'action': 'favourite_tutorial',
            'tutorial_id': save.data( 'post-id' )
        };
        $.post( theme_data.ajax_url, data )
            .done( function( response ) {
                anchor.find( '.spinner' ).removeClass( 'is-active' );
                if ( 'remove' === save.data( 'status' ) ) {
                    save.data( 'status', 'save' );
                    anchor.find( '.bookmark' ).show().removeClass( 'remove' ).addClass( 'save' );
                } else {
                    save.data( 'status', 'remove' );
                    anchor.find( '.bookmark' ).show().removeClass( 'save' ).addClass( 'remove' );
                }
            })
            .fail( function( jqXHR, textStatus, errorThrown ) {
                // Handle error
                console.error( 'AJAX request failed: ' + textStatus, errorThrown );
                console.error( 'Response: ', jqXHR.responseText );
            });
    });
	// bookmarking within help section (Legacy)
    $( '.help-wrap' ).on( 'click', '#add-bookmark, #remove-bookmark', function( e ) {
        e.preventDefault();
        var button = $( this );
        button.hide();
        var update_text = button.next( 'p' );
        update_text.removeClass( 'hide' );
        var data = {
            'action': 'favourite_tutorial',
            'tutorial_id': button.data( 'post-id' )
        };
        $.post( theme_data.ajax_url, data )
            .done( function( response ) {
                if ( $( '.bookmark-tut' ).is( ':visible' ) ) {
                    $( '.bookmark-tut' ).addClass( 'hide' );
                    $( '.bookmarked-tut' ).removeClass( 'hide' );
                } else {
                    $( '.bookmarked-tut' ).addClass( 'hide' );
                    $( '.bookmark-tut' ).removeClass( 'hide' );
                }
                update_text.addClass( 'hide' );
                button.show();
            })
            .fail( function( jqXHR, textStatus, errorThrown ) {
                // Handle error
                console.error( 'AJAX request failed: ' + textStatus, errorThrown );
                console.error( 'Response: ', jqXHR.responseText );
            });
    });
});
